import { render, staticRenderFns } from "./fillTheBlank.vue?vue&type=template&id=c87caee4&"
import script from "./fillTheBlank.vue?vue&type=script&lang=js&"
export * from "./fillTheBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports